import {
    BarChart,
} from '@mui/x-charts'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { TEST_CASE_STATUS } from 'pages/SingleJourney/components/TestCasesTab/constants';

const AccordionChart = (props) => {
    const { testCasesData } = props;

    const [chartData, setChartData] = useState({});

    const labels = Object.keys(chartData);
    const passedData = labels.map(item => chartData[item].passed);
    const failedData = labels.map(item => chartData[item].failed);
    const generatedData = labels.map(item => chartData[item].generated);
    const hasData = labels.length > 0;

    useEffect(() => {
        if (!testCasesData) return;
        const newChartData = {};
        testCasesData.forEach((item) => {
            const date = new Date(); // Replace with item.date if available
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            const key = `${month}/${day}/${year}`;

            let chartDataItem = newChartData[key];
            if (!chartDataItem) chartDataItem = { passed: 0, failed: 0, generated: 0 };

            const formattedItem = {
                passed: chartDataItem.passed + (item.status === TEST_CASE_STATUS.completed ? 1 : 0),
                failed: chartDataItem.failed + (
                    item.status === TEST_CASE_STATUS.failed ||
                    item.status === TEST_CASE_STATUS.initialFailure
                        ? 1
                        : 0
                ),
                generated: chartDataItem.generated + 1,
            }

            newChartData[key] = formattedItem;
        })
        setChartData(newChartData);
    }, [testCasesData])

    return (
        <Box>
            <BarChart
                xAxis={[{ id: 'date', data: labels, scaleType: 'band' }]}
                tooltip={{ trigger: hasData ? 'axis' : 'none' }}
                series={[
                    {
                        id: 'passed',
                        data: passedData,
                        label: 'Passed Tests',
                        color: '#8bc34a',
                    },
                    {
                        id: 'failed',
                        data: failedData,
                        label: 'Failed Tests',
                        color: '#f44336',
                    },
                    {
                        id: 'generated',
                        data: generatedData,
                        label: 'Total Tests',
                        color: '#2196f3',
                    },
                ]}
                height={300}
                margin={{ top: 70, bottom: 30, left: 40, right: 20 }}
            />
        </Box>
    )
}

export default AccordionChart
